import _ from 'lodash';
import { LatestNewsCard } from '../types';

const CHUNK_SIZE = 3;
const NEWS_COUNT = 12;

interface DatedLatestNewsCard {
  newsCard: LatestNewsCard,
  date: Date
}

export const getPagedNews = async (feeds: string[]): Promise<LatestNewsCard[][]> => {
  let news: DatedLatestNewsCard[] = [];

  for (let i = 0; i < feeds.length; i++) {
    try {
      const response = await fetch(feeds[i]);

      if (!response.ok) {
        continue;
      }

      const decodedResponse = await response.text();
      const xmlData = new window.DOMParser().parseFromString(decodedResponse, 'text/xml');
      const rssFeed = xmlData.querySelector('rss');

      news = [
        ...news,
        ...buildNewsItems(
          Array.from(xmlData.querySelectorAll('item')),
          rssFeed?.getAttribute('xmlns:media') || ''
        )
      ];
    } catch (err) {
      console.error(err);
    }
  }

  if (news.length === 0) {
    throw new Error("Failed to fetch items for news feed");
  }

  news.sort((a, b) => {
    return b.date.getTime() - a.date.getTime();
  });

  return _.chunk(news.map(n => n.newsCard).slice(0, NEWS_COUNT), CHUNK_SIZE);
}

const buildNewsItems = (items: Element[], mediaNamespace: string): DatedLatestNewsCard[] => {
  return items.map(item =>
    ({
      newsCard: {
        id: item.querySelector('guid')?.textContent || '',
        imageUrl: item.getElementsByTagNameNS(mediaNamespace, 'content')[0]?.getAttribute('url') || '',
        tag: item.querySelector('category')?.textContent || '',
        postTitle: sliceLongStrings(item.querySelector('title')?.textContent) || '',
        summary: sliceLongStrings(item.querySelector('description')?.textContent) || '',
        postUrl: item.querySelector('link')?.textContent || '',
      },
      date: new Date(item.querySelector('pubDate')?.textContent || '')
    })
  );
};

const sliceLongStrings = (itemForSlice: string|null|undefined): string|null|undefined => {
  if (itemForSlice && itemForSlice.length > 256) {
    return itemForSlice.slice(0, 256) + '...';
  }

  return itemForSlice;
}
